const roles = ['user', 'configurator', 'admin'];

export default roles;



// WEBPACK FOOTER //
// ./src/utils/userRoles.js